import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = {
  key: 0,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center text-muted py-20"
}
const _hoisted_10 = { class: "pagination-area d-md-flex mt-15 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AffectationCaisseModal = _resolveComponent("AffectationCaisseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "fw-bold text-black mb-0" }, "Historique des affectations", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "search-bg svg-color pt-3",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchAffectations && _ctx.searchAffectations(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchAffectations && _ctx.searchAffectations(...args))),
              class: "form-control shadow-none text-black",
              placeholder: "Rechercher..."
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.affectations.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Utilisateur"),
                    _createElementVNode("th", null, "Caisse"),
                    _createElementVNode("th", null, "Date d'affectation"),
                    _createElementVNode("th", null, "Statut"),
                    _createElementVNode("th", null, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affectations, (affectation, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(affectation.user ? `${affectation.user.nom} ${affectation.user.prenom}` : 'N/A'), 1),
                      _createElementVNode("td", null, _toDisplayString(affectation.caisse?.nom || 'N/A'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(affectation.dateAffectation)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(affectation.statut === 'ACTIF' ? 'badge bg-success' : 'badge bg-secondary')
                        }, _toDisplayString(affectation.statut), 3)
                      ]),
                      _createElementVNode("td", null, [
                        (affectation.statut === 'INACTIF')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-warning",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#AffectationCaisseModal",
                              onClick: ($event: any) => (_ctx.handleReaffecter(affectation))
                            }, _cache[5] || (_cache[5] = [
                              _createElementVNode("i", { class: "flaticon-shield me-1" }, null, -1),
                              _createTextVNode(" Réaffecter ")
                            ]), 8, _hoisted_7))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, "—"))
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, " Aucune affectation trouvée "))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.currentPage,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AffectationCaisseModal, {
      selectedAffectation: _ctx.selectedAffectation,
      onAffectee: _ctx.recharger
    }, null, 8, ["selectedAffectation", "onAffectee"])
  ], 64))
}